<div class="match-tune-dialog">
  <button type="button" class="dialog-close" (click)="close()" aria-label="Close">
    <i class="bi bi-x-lg"></i>
  </button>

  <div class="dialog-body">
    <ng-container *ngIf="error">
      <div class="error-block">
        <i class="bi bi-exclamation-triangle"></i>
        <p>{{ error }}</p>
        <button type="button" class="primary-btn" (click)="close()">Close</button>
      </div>
    </ng-container>

    <ng-container *ngIf="!error && currentStep === UploadingSteps.STOCK_FILE_OPTIONS && !stockFileDTO">
      <div class="mt-analyzing-card">
        <header class="mt-analyzing-head">
          <div class="mt-analyzing-titles">
            <h2 class="mt-analyzing-title">Match and Tune Files</h2>
            <p class="mt-analyzing-sub">Reading ECU signature and detecting vehicle…</p>
          </div>
          <span class="mt-pill mt-pill--analyzing">
            <span class="mt-pill-dot"></span>
            ANALYZING
          </span>
        </header>

        <div class="mt-analyzing-panel">
          <div class="mt-progress-ring-wrap">
            <svg class="mt-progress-svg" width="96" height="96" viewBox="0 0 96 96" aria-hidden="true">
              <circle cx="48" cy="48" r="40" fill="none" stroke="#7C5CFC2E" stroke-width="6" />
              <circle
                class="mt-progress-arc"
                cx="48"
                cy="48"
                r="40"
                fill="none"
                stroke="#7C5CFC"
                stroke-width="6"
                stroke-linecap="round"
                [attr.stroke-dasharray]="(progressWidth / 100) * progressRingLen + ' ' + progressRingLen"
                transform="rotate(-90 48 48)" />
            </svg>
            <span class="mt-progress-pct">{{ progressWidth }}%</span>
          </div>

          <div class="mt-file-lines">
            <p class="mt-file-name">{{ fileName || '…' }}</p>
            <p class="mt-file-meta">{{ fileSizeLabel }} · matching against ECU database</p>
          </div>

          <div class="mt-checklist">
            <div class="mt-check-row">
              <span class="mt-check-icon mt-check-icon--done" *ngIf="analyzingStep1Done()">✓</span>
              <span class="mt-check-icon mt-check-icon--spin" *ngIf="!analyzingStep1Done() && progressWidth > 0">⟳</span>
              <span class="mt-check-icon mt-check-icon--wait" *ngIf="!analyzingStep1Done() && progressWidth === 0">·</span>
              <span [class.mt-check-muted]="!analyzingStep1Done()" [class.mt-check-active]="analyzingStep1Done()">
                File parsed successfully
              </span>
            </div>
            <div class="mt-check-row">
              <span class="mt-check-icon mt-check-icon--done" *ngIf="analyzingStep2Done()">✓</span>
              <span class="mt-check-icon mt-check-icon--spin" *ngIf="!analyzingStep2Done() && analyzingStep1Done()">⟳</span>
              <span class="mt-check-icon mt-check-icon--wait" *ngIf="!analyzingStep1Done()">·</span>
              <span [class.mt-check-muted]="!analyzingStep2Done()" [class.mt-check-active]="analyzingStep2Done()">
                ECU signature read
              </span>
            </div>
            <div class="mt-check-row">
              <span class="mt-check-icon mt-check-icon--done" *ngIf="analyzingStep3Done()">✓</span>
              <span class="mt-check-icon mt-check-icon--spin" *ngIf="analyzingStep3Active()">⟳</span>
              <span class="mt-check-icon mt-check-icon--wait" *ngIf="!analyzingStep3Done() && !analyzingStep3Active()">·</span>
              <span [class.mt-check-muted]="!analyzingStep3Active() && !analyzingStep3Done()" [class.mt-check-strong]="analyzingStep3Active() || analyzingStep3Done()">
                Matching against vehicle database…
              </span>
            </div>
            <div class="mt-check-row">
              <span class="mt-check-icon mt-check-icon--spin" *ngIf="analyzingStep4Active()">⟳</span>
              <span class="mt-check-icon mt-check-icon--wait" *ngIf="!analyzingStep4Active()">·</span>
              <span [class.mt-check-muted]="!analyzingStep4Active()" [class.mt-check-strong]="analyzingStep4Active()">
                Loading available tunings
              </span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!error && stockFileDTO">
      <app-user-inputs
        [stockFileDTO]="stockFileDTO"
        [paperLayout]="true"
        (requestSent)="onRequestSent($event)"
        (closeDialog)="close()"></app-user-inputs>
    </ng-container>
  </div>
</div>
